import {
  GET_DL_BULK_REQUEST,
  GET_DL_BULK_SUCCESS,
  GET_DL_BULK_ERROR,
  GET_WW_BULK_REQUEST,
  GET_WW_BULK_SUCCESS,
  GET_WW_BULK_ERROR,
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";

export const GetDLBulk = (token, data) => (dispatch) => {
  dispatch({ type: GET_DL_BULK_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/DLBulkReport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      gender_id: data.gender_id === undefined || data.gender_id === "All" ? null : data.gender_id ,
      sku: data.sku === "All" ? null : data.sku,
      style_id: data.style_id === undefined || data.style_id === "All" ? null : data.style_id,   
      season_id: data.current_season_id === undefined || data.current_season_id === "All" ? null : data.current_season_id,
      wash_id: data.wash_id === undefined || data.wash_id === "All" ? null : data.wash_id
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_DL_BULK_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_DL_BULK_ERROR,
        payload: [],
      });
    });
};

export const GetWWBulk = (token, data) => (dispatch) => {
  dispatch({ type: GET_WW_BULK_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/WWBulkReport`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {
      gender_id: data.gender_id === undefined || data.gender_id === "All" ? null : data.gender_id ,
      sku: data.sku === "All" ? null : data.sku,
      style_id: data.style_id === undefined || data.style_id === "All" ? null : data.style_id,
      season_id: data.current_season_id === undefined || data.current_season_id === "All" ? null : data.current_season_id,
      wash_id: data.wash_id === undefined || data.wash_id === "All" ? null : data.wash_id
    },
  })
    .then((response) => {
      return dispatch({
        type: GET_WW_BULK_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_WW_BULK_ERROR,
        payload: [],
      });
    });
};
